import React, { useState } from 'react';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../ui/select';
import { InputGroup } from 'react-bootstrap';
import useLocalization from '../../hooks/useLocalization';
import DecimalInput from './DecimalInput';
import CurrencyInput from './CurrencyInput';

const units = ['ILS', '%'];

const CurrencyInputWithUnitDropdown = ({
  isRtlLanguage,
  value,
  percentValue,
  onChange,
  onChangePercent,
  tabIndex,
  readOnlyMode,
  disabled
}) => {
  const [mode, setMode] = useState(units[0]);
  const { translate } = useLocalization();

  return (
    <div className={`d-flex align-items-center w-100 gap-1`}>
      <InputGroup size="sm" className="flex gap-1">
        {mode === 'ILS' ? (
          <CurrencyInput
            tabIndex={tabIndex}
            className="m-0"
            size="sm"
            disabled={readOnlyMode}
            value={value}
            onChange={onChange}
          />
        ) : (
          <DecimalInput
            tabIndex={tabIndex}
            className="m-0"
            size="sm"
            disabled={readOnlyMode}
            value={percentValue}
            onChange={onChangePercent}
          />
        )}
        <Select value={mode} onValueChange={setMode} disabled={disabled}>
          <SelectTrigger className="w-[60px] rounded-none p-2 shadow-none m-0">
            <SelectValue placeholder="Select option" />
          </SelectTrigger>
          <SelectContent className="bg-white rounded-none p-0 m-0">
            {units.map(unit => (
              <SelectItem
                className={`hover:bg-gray-100 transition-colors rounded-none m-0 ${
                  unit === mode ? '!bg-blue-100 !text-blue-700 font-medium' : ''
                }`}
                key={unit}
                value={unit}
              >
                {translate(unit) || unit}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </InputGroup>
    </div>
  );
};

export default CurrencyInputWithUnitDropdown;
